module.exports = __webpack_public_path__ + "img/icon-login.988184fd.png";